import React from "react";

const ProductReviewsCards = ({ reviews }) => {
    if (reviews?.length === 0) return null;
    return (
        <div className="reviews-cards">
            {reviews && (reviews.map((review) => (
                <div key={review?.author_name} className="reviews-cards__item">
                    <div className="reviews-cards__item-inner">
                        <p className="reviews-cards__item-content">
                            {review?.content}
                        </p>
                        <div className="reviews-cards__item-author">
                            <div className="reviews-cards__item-author-image">
                                {review?.image ? <img src={review?.image} /> : (
                                    <p className="">
                                        {review?.author_name?.charAt(0)}
                                    </p>
                                )}

                            </div>
                            <div className="reviews-cards__item-author-details">
                                <p className="reviews-cards__item-author-name">
                                    {review?.author_name}
                                </p>
                                <p className="reviews-cards__item-author-place">
                                    {review?.author_place}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )))}
        </div>
    );
};

export default ProductReviewsCards;
